import styled from 'styled-components';
import { colors } from 'assets/styled/tokens';

import checkIcon from '../assets/check.svg';
import minusIcon from '../assets/minus.svg';

const iconCheckboxAllFactory = isAllSelected => {
  return isAllSelected ? checkIcon : minusIcon;
};

export const StyledCheckbox = styled.label`
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin: 12px 0;
  :hover {
    cursor: pointer;
  }

  p {
    margin-left: 0.6875rem;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.25rem;
    color: #888888;
  }

  span {
    min-width: 18px;
    min-height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.white};
    border: 0.1875rem solid ${colors.lightGray};
    border-radius: 0.1875rem;
  }

  input:checked + span {
    background: ${colors.primary};
    border-color: ${colors.primary};

    &::after {
      content: '';
      display: block;
      width: 0.625rem;
      height: 0.625rem;

      background: ${props =>
        props.isCheckboxAll
          ? `url(${iconCheckboxAllFactory(props?.isAllSelected)}) no-repeat center/contain`
          : `url(${checkIcon}) no-repeat center/contain`};
    }
  }
`;

export const StyledInput = styled.input`
  position: absolute;
  z-index: -1;
  display: none;
  margin: 0;
`;
export const SubLabel = styled.p`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  color: #888888;
  padding-left: 25px;
`;
